(function () {
	if (window.__swatchInitialized) return;
	window.__swatchInitialized = true;

	const CSS_CLASSES = {
		stockInfo: 'variantDeliveryBox__delivery--stock',
		header: 'variantDeliveryBox__delivery--header',
		date: 'variantDeliveryBox__delivery--date',
	};

	const VARIANT_STATES = {
		ESTIMATED_DELIVERY: 'estimatedDelivery',
		COMING_SOON: 'comingSoon',
		SOLD_OUT: 'soldOut',
	};

	const STATE_MODIFIERS = {
		[VARIANT_STATES.ESTIMATED_DELIVERY]: 'variantDeliveryBox__delivery--in-stock',
		[VARIANT_STATES.COMING_SOON]: 'variantDeliveryBox__delivery--expecting',
		[VARIANT_STATES.SOLD_OUT]: 'variantDeliveryBox__delivery--sold-out',
	};

	const COUNTRY_TRANSIT_DAYS = {
		'sava-bicycles.cz': 0,
		'sava-bicycles.sk': 1,
		'sava-bicycles.pl': 1,
		'sava-bicycles.de': 1,
		'sava-bicycles.nl': 1,
		'sava-bicycles.be': 1,
		'sava-bicycles.fr': 2,
		'sava-bicycles.it': 3,
		'sava-bicycles.es': 3,
	};
	const DEFAULT_TRANSIT_DAYS = 3;
	const REFRESH_INTERVAL_MS = 10 * 60 * 1000;
	const LOW_STOCK_THRESHOLD = 5;

	// ---------- Delivery date math ----------

	function getCountryTransitDays() {
		const hostname = window.location.hostname;
		for (const [domain, days] of Object.entries(COUNTRY_TRANSIT_DAYS)) {
			if (hostname.includes(domain)) return days;
		}
		return DEFAULT_TRANSIT_DAYS;
	}

	function getDispatchDelayDays() {
		const pragueNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Prague' }));
		const day = pragueNow.getDay();
		const hour = pragueNow.getHours();

		if (day === 5 && hour >= 10) return 3;
		if (day === 6) return 2;
		if (day === 0) return 1;
		if (hour >= 15) return 1;
		return 1;
	}

	function lookupStoreNextDelivery(deliveryDays) {
		const node = document.querySelector('[data-product-stores]');
		if (!node) return null;
		let stores;
		try {
			stores = JSON.parse(node.textContent);
		} catch (e) {
			return null;
		}
		const match = stores.find(s => s.delivery === deliveryDays);
		if (!match || !match.next_delivery) return null;
		const date = new Date(match.next_delivery);
		return isNaN(date.getTime()) ? null : date;
	}

	function computeEstimatedDeliveryDate(deliveryDays) {
		const today = new Date();
		today.setHours(0, 0, 0, 0);
		const totalDays = (deliveryDays || 0) + getCountryTransitDays() + getDispatchDelayDays();
		today.setDate(today.getDate() + totalDays);

		// Carriers deliver Mon-Fri: roll a weekend arrival forward to Monday.
		const arrivalDay = today.getDay();
		if (arrivalDay === 6) today.setDate(today.getDate() + 2);
		else if (arrivalDay === 0) today.setDate(today.getDate() + 1);

		return today.toLocaleDateString();
	}

	// ---------- DOM data parsing ----------

	function parseDeliveryDays(element) {
		const raw = element.dataset.variantDeliveryDays;
		if (raw == null || raw === 'null' || raw === '') return null;
		const parsed = parseInt(raw, 10);
		return Number.isFinite(parsed) ? parsed : null;
	}

	function parseDeliveryDateOverride(element) {
		const raw = element.dataset.variantDeliveryDate;
		if (raw == null || raw === 'null' || raw === '') return null;
		const date = new Date(raw);
		return isNaN(date.getTime()) ? null : date;
	}

	function getDeliveryInfo(element) {
		const days = parseDeliveryDays(element);
		const dateOverride = parseDeliveryDateOverride(element);
		const isAvailable = element.dataset.available === 'true';

		if (!isAvailable) {
			return { state: VARIANT_STATES.SOLD_OUT, date: '' };
		}

		if (days === 2) {
			const date = dateOverride
				? new Date(dateOverride).toLocaleDateString()
				: computeEstimatedDeliveryDate(days);
			return { state: VARIANT_STATES.ESTIMATED_DELIVERY, date };
		}

		// Coming soon: a per-variant estimated_delivery_date beats the warehouse's generic next_delivery.
		const comingSoonDate = dateOverride || lookupStoreNextDelivery(days);
		return {
			state: VARIANT_STATES.COMING_SOON,
			date: comingSoonDate ? comingSoonDate.toLocaleDateString() : '',
		};
	}

	// ---------- UI rendering ----------

	function createAvailabilityElement({ state, date }) {
		const translation = window.translations?.[state] ?? '';
		const element = document.createElement('div');
		element.classList.add(CSS_CLASSES.stockInfo);
		const modifier = STATE_MODIFIERS[state];
		if (modifier) element.classList.add(modifier);
		element.innerHTML =
			`<span class="${CSS_CLASSES.header}">${translation}</span>` +
			`<span class="${CSS_CLASSES.date}">${date}</span>`;
		return element;
	}

	function renderDeliveryInfo(target, sourceElement) {
		const existing = target.querySelector('.' + CSS_CLASSES.stockInfo);
		if (existing) existing.remove();
		target.appendChild(createAvailabilityElement(getDeliveryInfo(sourceElement)));
	}

	function updateSummaryDeliveryInfo() {
		const summary = document.querySelector('#swatch-sizes-btn');
		if (!summary) return;
		const target = document.querySelector('.swatch-sizes-btn__delivery') || summary;
		renderDeliveryInfo(target, summary);
	}

	function updateVariantAvailability(variantId) {
		const input = document.querySelector(`input[data-variantId="${variantId}"]`);
		if (!input) return;
		const label = document.querySelector(`[for="${input.id}"]`);
		if (!label) return;
		renderDeliveryInfo(label, input);
	}

	// ---------- Variant badge state ----------

	function getVariantInventory(variantId) {
		const input = document.querySelector(`input[data-variantId="${variantId}"]`);
		if (!input) return { managed: false, qty: 0 };
		const qty = parseInt(input.dataset.inventory, 10);
		return {
			managed: input.dataset.inventoryManaged === 'true',
			qty: Number.isFinite(qty) ? qty : 0,
		};
	}

	function getVariantSavaStock(variantId) {
		const input = document.querySelector(`input[data-variantId="${variantId}"]`);
		const qty = input ? parseInt(input.dataset.savaStock, 10) : NaN;
		return Number.isFinite(qty) ? qty : null;
	}

	function setStockCount(chip, selector, qty) {
		const items = chip.querySelector(selector);
		if (items) items.textContent = String(qty);
	}

	function applyVariantBadge(variant, deliveryDays) {
		const chip = document.querySelector('.stock-chip');
		if (!chip) return;

		if (!variant.available) {
			chip.dataset.chipState = 'soldout';
			return;
		}

		if (deliveryDays !== 2) {
			chip.dataset.chipState = 'expecting';
			return;
		}

		if (chip.dataset.b2b === 'true') {
			const savaStock = getVariantSavaStock(variant.id);
			if (savaStock !== null && savaStock > 0) {
				setStockCount(chip, '.stockLbl.b2bstock .items', savaStock);
				chip.dataset.chipState = 'b2bstock';
			} else {
				chip.dataset.chipState = 'instock';
			}
			return;
		}

		const inventory = getVariantInventory(variant.id);
		if (inventory.managed && inventory.qty > 0 && inventory.qty <= LOW_STOCK_THRESHOLD) {
			setStockCount(chip, '.stockLbl.lowstock .items', inventory.qty);
			chip.dataset.chipState = 'lowstock';
		} else {
			chip.dataset.chipState = 'instock';
		}
	}

	function updateStockAndButton(variant) {
		const input = document.querySelector(`input[data-variantId="${variant.id}"]`);
		const deliveryDays = input ? parseDeliveryDays(input) : null;
		const addToCartBtn = document.querySelector('[name="add"]');
		const addToCartText = addToCartBtn?.querySelector('span');

		if (variant.available) {
			addToCartBtn?.removeAttribute('disabled');
			if (addToCartText && window.theme?.strings?.addToCart) {
				addToCartText.textContent = window.theme.strings.addToCart;
			}
		} else {
			addToCartBtn?.setAttribute('disabled', 'disabled');
			if (addToCartText && window.theme?.strings?.soldOut) {
				addToCartText.textContent = window.theme.strings.soldOut;
			}
		}
		applyVariantBadge(variant, deliveryDays);
	}

	// ---------- Variant change events ----------

	function getCheckedVariantFromDom() {
		const input = document.querySelector('.swatchInput:checked');
		if (!input) return null;
		return {
			id: input.dataset.variantid,
			available: input.dataset.available === 'true',
			_input: input,
		};
	}

	function handleVariantChange(variant) {
		const fromDom = getCheckedVariantFromDom();
		const resolved = variant || fromDom;
		if (!resolved) return;
		const input = document.querySelector(`input[data-variantId="${resolved.id}"]`) || fromDom?._input;
		applyVariantBadge(resolved, input ? parseDeliveryDays(input) : null);
	}

	function bindVariantChangeListeners() {
		document.addEventListener('variantChange', (event) => {
			handleVariantChange(event.variant || event.originalEvent?.variant || event.detail?.variant);
		});

		if (window.jQuery) {
			window.jQuery(document).on('variantChange', (event) => handleVariantChange(event.variant));
			const $section = window.jQuery('[data-section-type="product"]');
			if ($section.length) {
				$section.on('variantChange', (event) => handleVariantChange(event.variant));
			}
		}
	}

	function navigateToVariant(variantId) {
		const url = new URL(location.href);
		url.searchParams.set('variant', variantId);
		location.href = url.toString();
	}

	// The reload must carry the selection in the URL itself: relying on other
	// scripts to have rewritten ?variant= before the reload loses the selection
	// whenever they are not bound yet (deferred-load gap) or throw mid-chain.
	function getTargetVariantId(input) {
		if (input.dataset.issize === 'true') return input.dataset.variantid || null;

		// Colour radios carry the id of the *first* variant in that colour; prefer
		// the variant that keeps the currently selected size in the new colour.
		const newColor = input.closest('.swatch-element')?.dataset.value;
		const checkedSize = document.querySelector('.swatchInput[data-isSize="true"]:checked');
		const currentSize = checkedSize?.closest('.swatch-element')?.dataset.size;

		if (newColor && currentSize) {
			const match = document.querySelector(
				`.swatch-element.size[data-size="${CSS.escape(currentSize)}"][data-color="${CSS.escape(newColor)}"] input`
			);
			if (match?.dataset.variantid) return match.dataset.variantid;
		}
		return input.dataset.variantid || null;
	}

	function bindSwatchSelectionHandlers() {
		const summary = document.querySelector('#swatch-sizes-btn');
		document.querySelectorAll('.swatchInput').forEach(input => {
			input.addEventListener('change', () => {
				summary?.classList.add('summary-loading');
				const variantId = getTargetVariantId(input);
				setTimeout(() => {
					if (variantId) navigateToVariant(variantId);
					else location.reload();
				}, 300);
			});
		});
	}

	// A click that lands while the HTML is still streaming (before this script
	// executes) checks the radio but no handler sees it; reconcile against the
	// server-rendered variant on the summary and navigate if they differ.
	function reconcilePreloadSelection() {
		const summary = document.querySelector('#swatch-sizes-btn');
		const initialId = summary?.dataset.variantId;
		const checked = document.querySelector('.swatchInput[data-isSize="true"]:checked');

		if (!initialId || !checked?.dataset.variantid) return false;
		if (checked.dataset.variantid === initialId) return false;

		summary.classList.add('summary-loading');
		navigateToVariant(checked.dataset.variantid);
		return true;
	}

	// ---------- Periodic refresh ----------

	function refreshProductData() {
		const wrapper = document.querySelector('[data-swatch-product-handle]');
		const section = wrapper?.closest('[data-section-type="product"]');
		if (!section?.dataset.sectionId) return;

		// The Ajax Product API omits inventory quantities and delivery metafields.
		// Render the same section in the current locale and customer context instead.
		const url = new URL(window.location.href);
		url.searchParams.set('section_id', section.dataset.sectionId);
		return fetch(url.toString())
			.then(response => {
				if (!response.ok) throw new Error(`Stock refresh failed with HTTP ${response.status}`);
				return response.text();
			})
			.then(html => {
				const freshDocument = new DOMParser().parseFromString(html, 'text/html');
				const freshSection = Array.from(freshDocument.querySelectorAll('[data-section-id]'))
					.find(node => node.dataset.sectionId === section.dataset.sectionId);
				const freshWrapper = freshSection?.querySelector('[data-swatch-product-handle]');
				if (freshWrapper?.dataset.swatchProductHandle !== wrapper.dataset.swatchProductHandle) return;

				const fields = ['available', 'inventory', 'inventoryManaged', 'savaStock', 'incoming', 'variantDeliveryDays', 'variantDeliveryDate'];
				const prvQty = section.querySelector('.prvQty');
				for (const freshInput of freshWrapper.querySelectorAll('.swatchInput[data-isSize="true"]')) {
					const id = freshInput.dataset.variantid;
					const input = wrapper.querySelector(`input[data-variantId="${id}"]`);
					// A partial or invalid response must never erase known stock information.
					if (!input || !/^-?\d+$/.test(freshInput.dataset.inventory ?? '') ||
						!['true', 'false'].includes(freshInput.dataset.available)) continue;
					for (const field of fields) {
						if (field in freshInput.dataset) input.dataset[field] = freshInput.dataset[field];
					}
					input.closest('.swatch-element').classList.toggle('soldout', input.dataset.available === 'false');
					if (prvQty) {
						prvQty.dataset['v' + id] = input.dataset.inventory;
						// theme.js reads jQuery's cached data, which does not track attribute changes.
						window.jQuery?.(prvQty).data('v' + id, Number(input.dataset.inventory));
					}
				}

				const stores = section.querySelector('[data-product-stores]');
				const freshStores = freshSection.querySelector('[data-product-stores]');
				if (stores && freshStores) stores.textContent = freshStores.textContent;

				const selectedInput = wrapper.querySelector('.swatchInput[data-isSize="true"]:checked');
				if (selectedInput) {
					const summary = wrapper.querySelector('#swatch-sizes-btn');
					if (summary) {
						for (const field of ['available', 'variantDeliveryDays', 'variantDeliveryDate']) {
							summary.dataset[field] = selectedInput.dataset[field];
						}
					}
					updateStockAndButton({ id: selectedInput.dataset.variantid, available: selectedInput.dataset.available === 'true' });
				}

				updateSummaryDeliveryInfo();
				getVariantIdsFromDom().forEach(updateVariantAvailability);
			})
			.catch(error => {
				window.Sentry?.captureException(error, { tags: { area: 'stock-refresh' } });
			});
	}

	// ---------- Initialization ----------

	function getVariantIdsFromDom() {
		return Array.from(document.querySelectorAll('input.swatchInput[data-isSize="true"]'))
			.map(input => input.dataset.variantid)
			.filter(Boolean);
	}

	function init() {
		if (reconcilePreloadSelection()) return;

		updateSummaryDeliveryInfo();
		getVariantIdsFromDom().forEach(updateVariantAvailability);

		const selectedInput = document.querySelector('.swatchInput:checked');
		if (selectedInput) {
			applyVariantBadge(
				{ available: selectedInput.dataset.available === 'true', id: selectedInput.dataset.variantid },
				parseDeliveryDays(selectedInput)
			);
		}

		bindSwatchSelectionHandlers();
		bindVariantChangeListeners();

		setInterval(refreshProductData, REFRESH_INTERVAL_MS);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
